// extracted by mini-css-extract-plugin
module.exports =  {"inner-text":"a_ykmvM","innerText":"a_ykmvM","qr-placeholder":"XZMQGRF","qrPlaceholder":"XZMQGRF"};